import { render, staticRenderFns } from "./factory-choose.vue?vue&type=template&id=50bd469f&"
import script from "./factory-choose.vue?vue&type=script&lang=js&"
export * from "./factory-choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports